module.exports = __webpack_public_path__ + "static/img/gif2.360a9e4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/gif2.gif
// module id = weRw
// module chunks = 9